import * as firebase from 'firebase';

import * as types from '../actionTypes';

function messageForFirebaseAuthError(error) {
  switch (error.code) {
    case 'auth/wrong-password': return 'A senha que você digitou está errada!';
    case 'auth/invalid-email':
    case 'auth/user-not-found': return 'Seu email não foi encontrado!';
    case 'auth/user-disabled': return 'Seu usuário está desativado!';
    default:
      console.warn(`Authentication.signIn: Bad signIn with unhandled error.code => ${error}`);
      return 'Encontramos um problema e não conseguimos a sua autenticação!';
  }
}

export function observeAuth() {
  return (dispatch) => {
    dispatch({
      type: types.AUTH_STATE_SUBSCRIBE,
    });

    firebase.auth().onAuthStateChanged((user) => {
      dispatch({
        type: types.AUTH_STATE_PUBLISH,
        user: user ? { uid: user.uid, email: user.email } : null,
      });
    }, (error) => {
      dispatch({
        type: types.AUTH_STATE_FAILURE,
        error: { message: messageForFirebaseAuthError(error), code: error.code },
      });
    }, () => {
      dispatch({
        type: types.AUTH_STATE_UNSUBSCRIBE,
      });
    });
  };
}

export function signIn(email, password) {
  return (dispatch) => {
    dispatch({
      type: types.AUTH_SIGNIN_REQUEST,
    });

    firebase.auth().signInWithEmailAndPassword(email, password)
      .then(() => {
        dispatch({
          type: types.AUTH_SIGNIN_SUCCESS,
        });
      })
      .catch((error) => {
        dispatch({
          type: types.AUTH_SIGNIN_FAILURE,
          error: { message: messageForFirebaseAuthError(error), code: error.code },
        });
      });
  };
}

export function signOut() {
  return (dispatch) => {
    dispatch({
      type: types.AUTH_SIGNOUT_REQUEST,
    });

    firebase.auth().signOut()
      .then(() => {
        dispatch({
          type: types.AUTH_SIGNOUT_SUCCESS,
        });
      })
      .catch((error) => {
        dispatch({
          type: types.AUTH_SIGNOUT_FAILURE,
          error: { message: messageForFirebaseAuthError(error), code: error.code },
        });
      });
  };
}

let userProfileRef;
let userProfileObserver;

export function observeUserProfile(uid) {
  return (dispatch) => {
    dispatch({
      type: types.AUTH_USER_PROFILE_SUBSCRIBE,
    });

    userProfileRef = firebase.database().ref(`/users/${uid}`);
    userProfileObserver = userProfileRef
      .on('value', (userProfileSnapshot) => {
        const userProfile = userProfileSnapshot.val();
        if (userProfile) {
          dispatch({
            type: types.AUTH_USER_PROFILE_PUBLISH,
            userProfile,
          });
        } else {
          dispatch({
            type: types.AUTH_USER_PROFILE_PUBLISH_BLANK,
          });
        }
      }, () => {
        userProfileRef.off('value', userProfileObserver);
        dispatch({
          type: types.AUTH_USER_PROFILE_UNSUBSCRIBE,
        });
      });
  };
}

export function stopUserProfileObservation() {
  return (dispatch) => {
    if (userProfileRef) { userProfileRef.off('value', userProfileObserver); }

    dispatch({
      type: types.AUTH_USER_PROFILE_UNSUBSCRIBE,
    });
  };
}

export function changeCurrentUserFleet(fleetKey) {
  return (dispatch, getState) => {
    const { authState: { currentUser: { uid } } } = getState();

    if (!uid) { return; }

    dispatch({
      type: types.AUTH_USER_PROFILE_UPDATE_REQUEST,
    });

    firebase.database().ref(`/users/${uid}/`)
      .update({ fleet: fleetKey || null })
      .then(() => {
        dispatch({
          type: types.AUTH_USER_PROFILE_UPDATE_SUCCESS,
          attributes: { fleet: fleetKey },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.AUTH_USER_PROFILE_UPDATE_FAILURE,
          error,
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/Auth/auth.actions.js